import { useParams } from 'react-router-dom'
import { useSites } from '@/lib/api/hooks'
import type { Site } from '@/lib/api/types'

export type Pack = 'BESS' | 'DSEAR'

/** Display pack from the backend industry ('petrochem' shows as DSEAR). */
export const packOf = (industry?: string | null): Pack => (industry === 'petrochem' ? 'DSEAR' : 'BESS')

export type SiteView = { id: string; name: string; pack: Pack; industry: string }
const toView = (s: Site): SiteView => ({
  id: s.site_id,
  name: s.site_name,
  pack: packOf(s.industry),
  industry: s.industry,
})

/** Live site list (GET /sites) mapped to the view model the shell renders. */
export function useSiteList() {
  const q = useSites()
  return { sites: (q.data ?? []).map(toView), isLoading: q.isLoading }
}

/** The site in the URL (falls back to the first site) + the full list. */
export function useCurrentSite() {
  const { siteId } = useParams()
  const { sites, isLoading } = useSiteList()
  const site = sites.find((s) => s.id === siteId) ?? sites[0]
  return { site, siteId: siteId ?? site?.id, sites, isLoading }
}
